import React from "react";
import SchoolIcon from "@mui/icons-material/School";

interface SiteLogoProps {
    iconOnly?: boolean;
    height?: number;
}

const SiteLogo: React.FC<SiteLogoProps> = ({ iconOnly = false, height = 44 }) => {
    const fontSize = Math.round(height * 0.62);
    const gap      = Math.round(height * 0.2);

    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap,
                flexShrink: 0,
                textDecoration: "none",
                lineHeight: 1,
                // The brand is a Latin proper noun — never reorder it. Under a page
                // dir=rtl the flex items (icon + text, and the My/Edu/Link spans)
                // would otherwise reverse into "LinkEduMy". Pin the logo to LTR.
                direction: "ltr",
            }}
        >
            {/* ── SchoolIcon (graduation cap) ─────────────────────── */}
            <SchoolIcon style={{ fontSize: height, color: "#309255", flexShrink: 0 }} />

            {/* ── Text: "Edu" dark navy + "Link" green ───────────── */}
            {!iconOnly && (
                <span
                    style={{
                        fontFamily:
                            "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                        fontWeight: 800,
                        fontSize,
                        letterSpacing: "-0.02em",
                        lineHeight: 1,
                        display: "inline-flex",
                        alignItems: "baseline",
                        userSelect: "none",
                        whiteSpace: "nowrap",
                    }}
                >
                    <span style={{ color: "#1d2d50" }}>My </span>
                    <span style={{ color: "#1d2d50" }}>Edu</span>
                    <span style={{ color: "#309255" }}>Link</span>
                </span>
            )}
        </div>
    );
};

export default SiteLogo;
